<template>
  <span class="grey--text ma-2 pa-1">
    <div>
      <img class="pa-2" src="img/helpcare/logo-small.svg" width="120px" style="">
    </div>
    <div ><span class="black--text">{{ settings.companyName }}</span> {{ settings.companyType }}</div>
    <div >{{ settings.companyAddress }}</div>
    <div >{{ settings.companyZip }} {{ settings.companyCity }}</div>
    <div class="pt-2"><span class="black--text">Tel: </span> {{ settings.companyTel }}</div>
    <div><span class="black--text">N° BCE: </span> {{ settings.companyBCE }}</div>
    <div ><span class="black--text">N° Bank: </span> {{ settings.companyBank }}</div>
  </span>
</template>
<script>
/*
companyName
companyType
companyAddress
companyZip
companyCity
companyTel
companyBCE
companyBank
*/
export default {
  props: ['settings']
}
</script>
